/**
 * AddPersonCard Component
 *
 * Displays a dashed-border card for adding a new reference person.
 * Shows a plus icon with title and subtitle.
 * Height matches the ReferencePersonCard.
 */

import { Plus } from 'lucide-react';
import type { IAddPersonCardProps } from '@/@types/referencePersons';
import { cn } from '@/lib/utils';

function AddPersonCard({ onClick, disabled = false }: IAddPersonCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'w-full min-h-[374px] rounded-xl border-2 border-dashed',
        'flex flex-col items-center justify-center gap-4',
        'transition-colors duration-200',
        'border-border bg-transparent',
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-border-hover cursor-pointer'
      )}
    >
      {/* Plus Icon Container */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center bg-muted">
        <Plus className="w-7 h-7 text-muted-foreground" />
      </div>

      {/* Text Content */}
      <div className="flex flex-col items-center gap-1">
        <span className="text-base font-semibold text-muted-foreground">Add New Person</span>
        <span className="text-[13px] text-muted-foreground/70">Upload 3-5 reference photos</span>
      </div>
    </button>
  );
}

export { AddPersonCard };
